import React from 'react';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import parkingStations from '../data/parkingStations.json';

// Optional: Fix default icon issues with Leaflet (if markers don't show)
import L from 'leaflet';
import markerIconPng from 'leaflet/dist/images/marker-icon.png';
import markerShadowPng from 'leaflet/dist/images/marker-shadow.png';
// Import the custom marker logo (adjust the path if needed)
import customMarkerIcon from '../assets/cam-logo.png';
// Optionally, you can keep the default shadow or remove it:
//import markerShadowPng from 'leaflet/dist/images/marker-shadow.png';

// Create a custom icon using your logo
const customIcon = L.icon({
  iconUrl: customMarkerIcon,
  // Adjust the icon size to suit your image. You might need to tweak these numbers:
  iconSize: [60, 60],
  // The anchor is the point of the icon which will correspond to marker's location
  iconAnchor: [15, 30],
  // Where the popup should open relative to the iconAnchor
  popupAnchor: [0, -30],

});


// Configure the default icon for markers
const DefaultIcon = L.icon({
  iconUrl: markerIconPng,
  shadowUrl: markerShadowPng,
  iconSize: [25, 41],
  iconAnchor: [12, 41]
});
L.Marker.prototype.options.icon = DefaultIcon;

const MapView = () => {
  // Use Copenhagen's approximate center coordinates
  const defaultPosition = [55.6641, 12.5794];

  return (
    <MapContainer center={defaultPosition} zoom={12} style={{ height: '100vh', width: '100%' }}>
      <TileLayer
        attribution='&copy; OpenStreetMap contributors, Tiles &copy; JFM'
        url="https://tiles.jfmtech.dk/styles/osm-bright/{z}/{x}/{y}.png"
      />

      {parkingStations.map((station, index) => {
        // Convert the coordinate string to an array
        const position = JSON.parse(station.Coord);
        return (
          <Marker key={index} position={position} icon={customIcon}>
            <Popup>
              <div>
                <strong>{station.Name}</strong>
                <br />
                {station.Location}
                <br />
                Antal Kinesiske Kameraer: <strong>{station.Sum}</strong>
              </div>
            </Popup>
          </Marker>
        );
      })}
    </MapContainer>
  );
};

export default MapView;
